import { render, staticRenderFns } from "./TheSearchSuggestion.vue?vue&type=template&id=9dc53de0&"
import script from "./TheSearchSuggestion.vue?vue&type=script&lang=js&"
export * from "./TheSearchSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dc53de0')) {
      api.createRecord('9dc53de0', component.options)
    } else {
      api.reload('9dc53de0', component.options)
    }
    module.hot.accept("./TheSearchSuggestion.vue?vue&type=template&id=9dc53de0&", function () {
      api.rerender('9dc53de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheSearchSuggestion.vue"
export default component.exports